import React from 'react';

export function Button({
  children,
  variant = 'primary',
  loading = false,
  disabled = false,
  type = 'button',
  onClick,
  className = '',
  ...rest
}) {
  const classes = ['cta'];
  if (variant === 'ghost') classes.push('ghost');
  if (variant === 'danger') classes.push('danger');
  if (className) classes.push(className);
  return (
    <button
      type={type}
      className={classes.join(' ')}
      disabled={disabled || loading}
      onClick={onClick}
      {...rest}
    >
      {loading ? '...' : children}
    </button>
  );
}
